export const SAVE_BACKGROUND_IMAGE_FILE = 'SAVE_BACKGROUND_IMAGE_FILE'

export const saveBackgroundImageFile = payload => ({
  type: SAVE_BACKGROUND_IMAGE_FILE,
  payload,
})
